export const GET_TRAININGS = 'trainings/GET_TRAININGS';
export const GET_SCHOOL_TRAININGS = 'trainings/GET_SCHOOL_TRAININGS';
export const UPDATE_TRAINING_BY_ID = 'trainings/UPDATE_TRAINING_BY_ID';
export const REMOVE_TRAINING_BY_ID = 'trainings/REMOVE_TRAINING_BY_ID';
